import React from 'react';
import PropTypes from 'prop-types';
import chunk from 'lodash.chunk';
import { PROBE_DETAIL } from '../../../../constants/shared/CommonConstants';
import './RANProbeDetails.scss';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const RANProbeDetails = ({ result, content }) => {
    const ITEMS_IN_A_ROW = 10;
    const isItemCorect = itemId =>
        result.measureResult.responses.find(response => response.id === itemId).outcome ===
        PROBE_DETAIL.CORRECT_RESPONSE;

    return (
        <div className="container ran-container">
            {chunk(content.items, ITEMS_IN_A_ROW).map((rowItems, index) => {
                return (
                    <div key={generateReactKey(index)} className="ran-row">
                        {rowItems.map((item, itemIndex) => (
                            <div
                                key={generateReactKey(index, itemIndex)}
                                className={`ran-item ${isItemCorect(item.id) ? '' : 'incorrect'}`}
                            >
                                {item.text}
                            </div>
                        ))}
                    </div>
                );
            })}
        </div>
    );
};

RANProbeDetails.propTypes = {
    result: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
};

export default RANProbeDetails;
